<div class="flex-column">
    <span class="headline-1 mbs-5 text-primary-darker-title">
        {{ ('modules.admissions.case-management-data.template-title' | exp:'':'Gestión del caso')  }}
    </span>
        <app-theme-card themeScope="admissions" cardClass="pt-1">
            <div class="flex-column ml-4 flex-90">

                <form [formGroup]="this.formCaseManagement">

                    <span class="subtitle-3 text-primary-darker-h3">
                        {{ 'modules.admissions.case-management-data.operator' | exp:'':'Operador' }} *
                    </span>
                    <app-operator-select [name]="this.OPERATOR" [form]="this.formCaseManagement"
                        [placeholder]="('modules.admissions.case-management-data.placeholders.select-operator' | exp:'':'Seleccionar operador')" [elements]="this.operators"
                        [defaultValue]="" [calculateId]="this.calculateIdOperator"
                        [calculateName]="this.calculateNameOperator" [placeholderSearching]="('modules.admissions.case-management-data.placeholders.searching-operator' | exp:'':'Buscar operador...')"
                        [placeholderNoValue]="('modules.admissions.case-management-data.placeholders.no-value' | exp:'':'Sin resultados')" [nameSearching]="this.OPERATOR_SEARCHING">
                    </app-operator-select>

                    <span class="subtitle-3 text-primary-darker-h3">
                        {{ 'modules.admissions.case-management-data.add-note' | exp:'':'Agregar nota' }}
                    </span>
                    <app-text-area-input class="notes" [name]="this.NOTE" [form]="this.formCaseManagement"
                        [placeholder]="('modules.admissions.case-management-data.placeholders.note-write' | exp:'':'Escriba aquí')">
                    </app-text-area-input>
                    <div class="flex-row align-start-center flex-100"
                    style="z-index: 1; position: relative;top: -10px; height: fit-content; ">
                    <app-checkbox-input class="flex-8" [form]="this.formCaseManagement" [label]="('modules.admissions.case-management-data.critical-label' | exp:'':'Crítica')"
                        [labelPosition]="'before'" [name]="this.NOTE_CRITICAL"></app-checkbox-input>
                    <span *ngIf="this.formCaseManagement.get(this.NOTE_CRITICAL).value" class="flex- subtitle-4 text-validation-error">
                        <i>{{ 'modules.admissions.case-management-data.critical-advise' | exp:'':'“Al marcarla como crítica, se generará una tarea y se enviará un mail al operador del caso.”' }}</i>
                    </span>
                </div>
                </form>
            </div>
        </app-theme-card>
</div>
